import { Component } from '@angular/core';

@Component({
  selector: 'app-invoices',
  template: `
                <div>
                    <router-outlet></router-outlet>
                </div>
             ` ,
})

export class InvoicesComponent {

}
